import { DropdownButton, Dropdown } from "react-bootstrap";
import { ucfirst } from "../helpers/String";

export default function PerformanceGroupSelector({ value = "", onChange }) {
  const onClick = (report) => {
    if (onChange) {
      onChange(report);
    }
  };

  return (
    <div className="standard-dropdown">
      <div className="standard-dropdown-label">Group by:</div>
      <DropdownButton title={ucfirst(value)}>
        <Dropdown.Item onClick={() => onClick("day")} as="button">
          Day
        </Dropdown.Item>
        <Dropdown.Item onClick={() => onClick("month")} as="button">
          Month
        </Dropdown.Item>
      </DropdownButton>
    </div>
  );
}
